<template>
  <div id="app">
    <landing-page />
  </div>
</template>

<script>
  import LandingPage from '~/LandingPage';

  export default {
    name: 'App',
    components: { LandingPage }
  }
</script>
